import { render, staticRenderFns } from "./MarketingList.vue?vue&type=template&id=e5232f6e&scoped=true&"
import script from "./MarketingList.vue?vue&type=script&lang=js&"
export * from "./MarketingList.vue?vue&type=script&lang=js&"
import style0 from "./MarketingList.vue?vue&type=style&index=0&id=e5232f6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5232f6e",
  null
  
)

export default component.exports